import {
  ClipboardIcon,
  EmailIcon,
  FacebookBrandIcon,
  MessengerBrandIcon,
  PinterestIcon,
  TwitterBrandIcon,
  WhatsAppBrandIcon,
} from '@c/icons';
import DynamicToast from '@c/toasts/DynamicToast';
import Button from '@ui/Button';
import SafeImage from '@ui/SafeImage';
import { getHostUrl } from '@util/index';
import { useToastContext } from 'context/ToastContext';
import { useRouter } from 'next/router';
import BaseModal from './BaseModal';

type ShareType = 'user' | 'item' | 'blog';
const titles: Record<ShareType, string> = {
  user: 'Share Profile',
  item: 'Share Item',
  blog: 'Share Blog',
};
interface ShareModalProps {
  title: string;
  thumb: string;
  isOpen: boolean;
  dismiss: () => void;
  type?: ShareType;
}

const ShareModal = ({
  title,
  thumb,
  isOpen,
  dismiss,
  type = 'item',
}: ShareModalProps) => {
  const { showToast } = useToastContext();

  const displayToast = (text: string) => {
    showToast(<DynamicToast text={text} />, {
      style: {
        borderRadius: '10px',
        backgroundColor: '#FDF4E9',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: '#C75008',
        width: '400px',
      },
      position: 'bottom-center',
    });
  };

  const router = useRouter();
  const link = getHostUrl() + router.asPath;
  const encodedTitle = encodeURIComponent(title);
  const fbURL = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
  const twitterURL = `https://twitter.com/intent/tweet?url=${link}`;
  const pinterestURL = `https://www.pinterest.com/pin-builder/?media=${thumb}&method=button&url=${link}`;
  const whatsApp = `https://api.whatsapp.com/send/?text=Check+out+what+I+just+found+on+Gear+Focus%3A+${encodedTitle}%0A${link}&type=custom_url&app_absent=0`;
  const emailURL = `mailto:?to=&subject=Checkout%20${encodedTitle}%20on%20Gear%20Focus&body=${link}`;
  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={() => {
        dismiss();
      }}
      title={<h1 className="text-[2.4rem] font-semibold">{titles[type]}</h1>}
      width="45rem"
    >
      <div className="flex w-full max-w-[45rem] flex-col gap-[1.6rem]">
        <div className="flex flex-row">
          <SafeImage
            className="max-h-[8rem] max-w-[8rem] rounded-lg"
            unoptimized
            src={thumb}
            width={80}
            height={80}
            alt={title}
          />
          <h1 className="ml-[1.5rem] font-medium">{title}</h1>
        </div>
        <hr></hr>
        <Button
          leadingIcon={<ClipboardIcon />}
          type="gray"
          text="Copy Link"
          width="fluid"
          onClick={() =>
            navigator.clipboard.writeText(link).then(() => {
              displayToast('Link copied to clipboard.');
              dismiss();
            })
          }
        />
        <div className="grid grid-cols-2 gap-4">
          <div className=" flex-colfont-semibold text-brand-secondary">
            <Button
              leadingIcon={<FacebookBrandIcon />}
              type="gray"
              text="Facebook"
              align="left"
              width="fluid"
              onClick={() => window.open(fbURL)}
            />
          </div>
          <div className="flex-col font-semibold text-brand-secondary">
            <Button
              leadingIcon={<MessengerBrandIcon />}
              type="gray"
              text="Messenger"
              align="left"
              width="fluid"
              onClick={() => window.open(fbURL)}
            />
          </div>
          <div className=" flex-col font-semibold text-brand-secondary">
            <Button
              leadingIcon={<TwitterBrandIcon />}
              type="gray"
              text="Twitter"
              align="left"
              width="fluid"
              onClick={() => window.open(twitterURL)}
            />
          </div>
          <div className="flex-col font-semibold text-brand-secondary">
            <Button
              leadingIcon={<PinterestIcon />}
              type="gray"
              text="Pinterest"
              align="left"
              width="fluid"
              onClick={() => window.open(pinterestURL)}
            />
          </div>
          <div className="font-semibold text-brand-secondary">
            <Button
              leadingIcon={<WhatsAppBrandIcon />}
              type="gray"
              text="WhatsApp"
              align="left"
              width="fluid"
              onClick={() => window.open(whatsApp)}
            />
          </div>
          <div className="font-semibold text-brand-secondary">
            <Button
              leadingIcon={<EmailIcon />}
              type="gray"
              text="Email"
              align="left"
              width="fluid"
              onClick={() => window.open(emailURL)}
            />
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default ShareModal;
